import Accordion from "@/lib/Accordion";
import { NoteCreatedEvent } from "@/lib/queries/types";
import dayjs from "dayjs";
import { datetimeFormat } from "./utils";
import NoteIcon from "~icons/local/note";

export default function NoteCreated({ data }: { data: NoteCreatedEvent }) {
  const { event_time, note } = data;
  const { created_by, content } = note;

  return (
    <Accordion
      title={
        <div className="flex gap-1 items-center">
          <NoteIcon className="size-6" />
          <div className="font-bold ml-3">Note</div>
          <div className="text-sm text-slate-500">
            {`by ${created_by} ${dayjs(event_time).format(datetimeFormat)}`}
          </div>
        </div>
      }
    >
      <div className="pl-10 p-2">
        <Content content={content} />
      </div>
    </Accordion>
  );
}

function Content({ content }: { content: string }) {
  return (
    <div className="flex flex-col gap-1 text-sm">
      {content.split("\n").map((line, i) => (
        <div key={i}>{line}</div>
      ))}
    </div>
  );
}
